var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5C9.5 2.5 5 7 5 12.5C5 19.25 13.75 26.875 14.125 27.25C14.375 27.375 14.75 27.5 15 27.5C15.25 27.5 15.625 27.375 15.875 27.25C16.25 26.875 25 19.25 25 12.5C25 7 20.5 2.5 15 2.5ZM15 24.625C12.375 22.125 7.5 16.75 7.5 12.5C7.5 8.375 10.875 5 15 5C19.125 5 22.5 8.375 22.5 12.5C22.5 16.625 17.625 22.125 15 24.625ZM15 7.5C12.25 7.5 10 9.75 10 12.5C10 15.25 12.25 17.5 15 17.5C17.75 17.5 20 15.25 20 12.5C20 9.75 17.75 7.5 15 7.5ZM15 15C13.625 15 12.5 13.875 12.5 12.5C12.5 11.125 13.625 10 15 10C16.375 10 17.5 11.125 17.5 12.5C17.5 13.875 16.375 15 15 15Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiLocation);
export default __webpack_public_path__ + "static/media/mi_location.636803f29f1bc66511c4469da8bffd28.svg";
export { ForwardRef as ReactComponent };